import { offset } from "@floating-ui/dom"

/**
 * Configuration interfaces for FloatingUI options
 */
export interface OffsetOptions {
   mainAxis?: number
   crossAxis?: number
   alignmentAxis?: number | null
}

/**
 * Creates FloatingUI configuration with offset middleware
 * @param offsetOptions - Options for the offset middleware
 * @returns FloatingUI configuration object
 */
export const createOffsetConfig = (
   offsetOptions: OffsetOptions = { mainAxis: 25 },
) => {
   return {
      middleware: [offset(offsetOptions)],
   }
}

/**
 * Creates a standard offset configuration with mainAxis of 25px
 * Used in most tour steps
 */
export const standardOffset = createOffsetConfig()

/**
 * Creates a large offset configuration with mainAxis of 40px
 * Useful when you need more space between the tooltip and the target
 */
export const largeOffset = createOffsetConfig({ mainAxis: 40 })

/**
 * Creates a small offset configuration with mainAxis of 15px
 * Useful when you need the tooltip closer to the target
 */
export const smallOffset = createOffsetConfig({ mainAxis: 15 })

/**
 * Creates a custom offset configuration with both mainAxis and crossAxis
 * @param mainAxis - Offset on the main axis (vertical for top/bottom, horizontal for left/right)
 * @param crossAxis - Offset on the cross axis
 * @returns FloatingUI configuration object
 */
export const createCustomOffset = (mainAxis: number, crossAxis: number = 0) => {
   return createOffsetConfig({ mainAxis, crossAxis })
}
